import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SegmentItem from "./SegmentItem";
import { Card, Flex } from "antd";
import { useI18n } from "components/I18nProvider";
import { useEventAdminState } from "components/EventStateProvider";
import { fetchConfig } from "api/config";
import { buildUrlPath } from "lib/resolveUrl";
const SegmentsCard = () => {
    const navigate = useNavigate();
    const { intl } = useI18n();
    const { eventSnapshot, selectedSegmentId, setSelectedSegmentId } = useEventAdminState();
    const [languageEmojiFlags, setLanguageEmojiFlags] = useState({});
    useEffect(() => {
        void fetchConfig()
            .then((config) => setLanguageEmojiFlags(config.languageEmojiFlags ?? {}))
            .catch(() => setLanguageEmojiFlags({}));
    }, []);
    const handleSelectSegment = useCallback((segmentId) => {
        setSelectedSegmentId(segmentId);
        if (eventSnapshot !== null) {
            navigate(buildUrlPath(`/admin/events/${eventSnapshot.id}`));
        }
    }, [eventSnapshot, navigate, setSelectedSegmentId]);
    if (eventSnapshot === null) {
        return _jsx("p", { children: intl.formatMessage({ id: 'loading' }) });
    }
    return (_jsx(Card, { children: _jsx(Flex, { vertical: true, gap: "small", children: eventSnapshot.segments.map((segment) => _jsx(SegmentItem, { segment: segment, isActive: segment.isActive, isSelected: segment.id === selectedSegmentId, languageEmojiFlags: languageEmojiFlags, onSelect: handleSelectSegment }, segment.id)) }) }));
};
export default SegmentsCard;
